// Content Security Policy — full-page route override form (create / edit).

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteOverrideFormPage from "./components/RouteOverrideFormPage";

const ROUTES_PATH = "/v2/csp/routes";

export default function CspOverride() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialRow = location.state?.override ?? null;

  return (
    <RouteOverrideFormPage
      initialRow={initialRow}
      onCancel={() => navigate(ROUTES_PATH)}
      onSuccess={() => navigate(ROUTES_PATH)}
    />
  );
}
